import { FC, useState, ReactNode } from 'react';

import { Moment } from 'moment';

import FlightResponsiveSearchDrawerItem from '@domain/flight/searchBar/dateSelection/responsiveSearchDrawerItem/ResponsiveSearchDrawerItem';
import ResponsiveSearchDrawerItem, {
  ResponsiveDrawerInterface,
} from '@components/views/components/listing/drawer/ResponsiveSearchDrawerItem';
import ResponsiveDrawer from '@components/views/components/listing/drawer/ResponsiveDrawer';
import HotelResponsiveSearchDrawerItem from '@domain/hotel/searchBar/dateSelection/responsiveSearchDrawerItem/ResponsiveSearchDrawerItem';
import CarRentalMobilDateSelect from '@domain/carRental/searchBar/home/dateSelection/dateSelect/mobilDateSelect';

import { ResponsivePickerContent } from './ResponsiveSearchInputDrawerStyle';

type InputComponentsType =
  | 'shopAndFlyHomePageCarRental'
  | 'shopAndFlyHomePageFlight'
  | 'shopAndFlyHomePageHotel'
  | 'setur';

const InputComponents = {
  shopAndFlyHomePageCarRental: CarRentalMobilDateSelect,
  shopAndFlyHomePageFlight: FlightResponsiveSearchDrawerItem,
  shopAndFlyHomePageHotel: HotelResponsiveSearchDrawerItem,
  setur: ResponsiveSearchDrawerItem,
};

const ResponsiveSearchInputDrawer: FC<
  Omit<ResponsiveDrawerInterface, 'onClick'> & {
    drawerTitle?: string;
    inputComponent:
      | 'shopAndFlyHomePageCarRental'
      | 'shopAndFlyHomePageFlight'
      | 'shopAndFlyHomePageHotel'
      | 'setur';
    startDate?: Moment | null;
    endDate?: Moment | null;
    isSubmit?: boolean;
    onFocusChange?: (input: 'startDate' | 'endDate') => void;
  } & {
    children: (child: () => void) => ReactNode;
  }
> = ({
  children,
  inputComponent,
  drawerTitle,
  onFocusChange,
  ...otherProps
}) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  const ResponsiveSearchDrawerItemComponent =
    InputComponents[inputComponent as InputComponentsType];

  const hideModal = () => {
    setIsShowModal(false);
  };

  return isShowModal ? (
    <ResponsiveDrawer
      title={drawerTitle}
      visible={isShowModal}
      onClose={hideModal}
    >
      <ResponsivePickerContent>
        {children && children(hideModal)}
      </ResponsivePickerContent>
    </ResponsiveDrawer>
  ) : (
    <ResponsiveSearchDrawerItemComponent
      {...otherProps}
      onFocusChange={onFocusChange}
      onClick={() => setIsShowModal(true)}
    />
  );
};

export default ResponsiveSearchInputDrawer;
